import {http} from "../utils/http";
import {Response} from '../types/resp';
export const entertainment = {
	getCategoryByType: async (payload: any) => {
		return http.post<Response<any>>('/entertainment/get-category-by-type', payload)
	},

	getItemListByCategory: async (payload: any) => {
		return http.post<Response<any>>('/entertainment/get-item-list-by-category', payload)
	},

	getItemDetail: async (payload: any) => {
		return http.post<Response<any>>('/entertainment/get-item-detail', payload)
	},

	searchItem: async (payload: any) => {
		return http.post<Response<any>>('/entertainment/search-item', payload)
	},

	getCategoryAndItemList: async (payload: any) => {
		return http.post<Response<any>>('/entertainment/get-category-and-item-list', payload)
	},
}
